var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 121,
    viewBox: "0 0 116 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.669 87.7208C104.372 102.42 96.5919 113.487 86.9529 118.237C78.4367 121.643 66.4017 117.846 51.7379 107.114C37.1136 97.8174 22.6103 86.4849 11.9396 75.4796C2.53364 66.2879 -1.12544 54.8467 3.85341 41.5247C11.003 28.1603 24.4629 15.5113 39.6044 7.18398C54.6712 0.328802 70.8013 -0.331247 84.7582 7.15144C98.738 15.8056 108.103 29.3413 111.914 43.8702C115.883 57.6262 114.872 72.9617 108.669 87.7208Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector22);
export default __webpack_public_path__ + "static/media/Vector-22.db70875c43afeb779ccbb66f15389120.svg";
export { ForwardRef as ReactComponent };